import { render, staticRenderFns } from "./AllPushRequests.vue?vue&type=template&id=13635a71"
import script from "./AllPushRequests.vue?vue&type=script&lang=js"
export * from "./AllPushRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports